import React from 'react';

import "./scss/Cursor.scss"

const Cursor = ({ effects, position }) => (
    <div className={effects ? 'cursor' : 'no-effects cursor'} style={{ top: position.y, left: position.x }}></div>
)

export default Cursor